export const matchMedia = (query) => window.matchMedia(`(${query})`);
export const matchMinWidth = (width) =>
  matchMedia(`min-width: ${typeof width === 'string' ? width : width + 'px'}`);
export const matchMaxWidth = (width) =>
  matchMedia(`max-width: ${typeof width === 'string' ? width : width + 'px'}`);
